import { createFileRoute } from "@tanstack/react-router";
import ServicePageQaCopy from "@/pages/ServicePageQaCopy";

// Unlisted working copy of the Quality Assurance page (direct link only, noindex).
export const Route = createFileRoute("/en/services/quality-assurance-copy")({
  head: () => ({
    meta: [
      { title: "Quality Assurance (QA) Services | QbD Group" },
      { name: "description", content: "Experienced QA professionals and targeted services for pharma, biotech and MedTech: inspection readiness, GxP audits, QMS, CAPA, QP/RP and PQR support." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Quality Assurance (QA) Services | QbD Group" },
      { property: "og:description", content: "Experienced QA professionals and targeted services for pharma, biotech and MedTech: inspection readiness, GxP audits, QMS, CAPA, QP/RP and PQR support." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: ServicePageQaCopy,
});
